export default __webpack_public_path__ + "static/media/rate_logo.6fc665fc.png";